;(function () {
  'use strict'

  angular
    .module('contrast.tutorial')
    .factory(
      'tutorialModalService',
      function tutorialModalServiceFactory($uibModal) {
        'ngInject'

        var _tplPrefix = 'components-org/tutorial',
          _assessTpl = _tplPrefix + '/modal-assessment-start.html',
          _protectTpl = _tplPrefix + '/modal-protection-start.html',
          _protectAllTpl = _tplPrefix + '/modal-protection-start-all.html'

        var service = {
          openAssess: openAssess,
          openProtect: openProtect,
          openProtectAll: openProtectAll
        }

        function openAssess() {
          return _open(_assessTpl)
        }

        function openProtect() {
          return _open(_protectTpl)
        }

        function openProtectAll() {
          return _open(_protectAllTpl)
        }

        function _open(tpl) {
          return $uibModal.open({
            templateUrl: tpl,
            controller: 'TutorialModalCtrl',
            size: 'md-sm',
            openedClass: 'modal-open tutorial-modal'
          }).result
        }

        return service
      }
    )
})()
